import { fadeInAnimation } from "./namespace/fadeInAnimation";

document.addEventListener("DOMContentLoaded", () => {
  fadeInAnimation();
});
